export default __webpack_public_path__ + "static/media/user-type-1.db6be0bf.png";